import template from './adpStatusIcon.html';
import controller from './adpStatusIcon.controller';
import './adpStatusIcon.less';

let adpStatusIconComponent = {
  restrict: 'E',
  bindings: {
  	status: '@',
  },
  template,
  controller
};

export default adpStatusIconComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpStatusIcon/adpStatusIcon.component.js